import crypto from 'crypto-browserify';
import base64url from 'base64url';

export const generateNonce = () => {
  const nonceBytes = crypto.randomBytes(32);
  const nonceEnc = base64url.encode(nonceBytes);
  const nonceHash = base64url.encode(crypto.createHash('sha256').update(nonceBytes).digest());
  return { nonceEnc, nonceHash };
};

export const isValidNonce = ({ nonceEnc, nonceHash }) => {
  const nonceBytes = base64url.toBuffer(nonceEnc);
  const hash = base64url.encode(crypto.createHash('sha256').update(nonceBytes).digest());
  return hash === nonceHash;
};
